import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-wifi" }),
  /*#__PURE__*/_createTextVNode(" Información de la Red de la Habitación: ")
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "nombre",
  class: "form-label"
}, "Nombre de la Red: *", -1)
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "pass",
  class: "form-label"
}, "Contraseña de la Red: *", -1)
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "mb-3 text-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Cifrado:", -1)
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "form-check form-check-inline" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "cif1",
  class: "ml-2"
}, "  Ninguno", -1)
const _hoisted_18 = { class: "form-check form-check-inline" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "cif2",
  class: "ml-2"
}, "  WPA/WPA2", -1)
const _hoisted_20 = { class: "form-check form-check-inline" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "cif3",
  class: "ml-2"
}, "  WEP", -1)
const _hoisted_22 = { class: "mb-3 text-center" }
const _hoisted_23 = {
  for: "ingredient1",
  class: "ml-2"
}
const _hoisted_24 = {
  for: "ingredient1",
  class: "ml-2"
}
const _hoisted_25 = { class: "mt-3 text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-qrcode" }, null, -1)
const _hoisted_27 = { class: "col-6" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "d-flex justify-content-center" }
const _hoisted_36 = { class: "row mt-5" }
const _hoisted_37 = { class: "col-md-12 text-center" }

export function render(_ctx, _cache) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_QrcodeVue = _resolveComponent("QrcodeVue")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.habitacion), 1)
    ]),
    _hoisted_3,
    _createElementVNode("form", {
      autocomplete: "off",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers((...args) => (_ctx.guardarExtras && _ctx.guardarExtras(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_InputText, {
                id: "nombre",
                autocomplete: "rutjfkde",
                type: "text",
                class: "vue-input",
                readonly: "",
                onfocus: "this.removeAttribute('readonly');",
                placeholder: "Nombre de la Red de Wi-Fi",
                modelValue: _ctx.extrasHabitacion.nombreRed,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.extrasHabitacion.nombreRed) = $event)),
                requiered: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_InputText, {
                id: "pass",
                autocomplete: "off",
                type: "password",
                class: "vue-input",
                placeholder: "Contraseña del Wi-Fi",
                modelValue: _ctx.extrasHabitacion.passwordRed,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.extrasHabitacion.passwordRed) = $event)),
                requiered: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_RadioButton, {
                    modelValue: _ctx.extrasHabitacion.cifrado,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.extrasHabitacion.cifrado) = $event)),
                    inputId: "cif1",
                    name: "extrasHabitacion",
                    value: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_RadioButton, {
                    modelValue: _ctx.extrasHabitacion.cifrado,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.extrasHabitacion.cifrado) = $event)),
                    inputId: "cif2",
                    name: "extrasHabitacion",
                    value: "WPA/WPA2"
                  }, null, 8, ["modelValue"]),
                  _hoisted_19
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_RadioButton, {
                    modelValue: _ctx.extrasHabitacion.cifrado,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.extrasHabitacion.cifrado) = $event)),
                    inputId: "cif3",
                    name: "extrasHabitacion",
                    value: "WEP"
                  }, null, 8, ["modelValue"]),
                  _hoisted_21
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.extrasHabitacion.esOculta,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.extrasHabitacion.esOculta) = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("label", _hoisted_23, "  La Red es Oculta (SI)", 512), [
                [_vShow, _ctx.extrasHabitacion.esOculta]
              ]),
              _withDirectives(_createElementVNode("label", _hoisted_24, "  La Red es Oculta (NO)", 512), [
                [_vShow, !_ctx.extrasHabitacion.esOculta]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Button, {
                type: "button",
                severity: "primary",
                onClick: _cache[6] || (_cache[6] = $event => (_ctx.generateQRCode())),
                title: "Generar Nuevo Código QR"
              }, {
                default: _withCtx(() => [
                  _hoisted_26,
                  _createTextVNode("  Generar Código QR ")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              (_ctx.extrasHabitacion.isQrUploaded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("img", {
                        src: _ctx.extrasHabitacion.urlQRImg,
                        alt: "#QR_Code"
                      }, null, 8, _hoisted_32)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.extrasHabitacion.isQrUploaded && _ctx.isQRGenereted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_QrcodeVue, {
                          id: "qrCoreGenerated",
                          value: _ctx.value,
                          level: 'L',
                          "render-as": 'canvas',
                          size: 300,
                          margin: 2
                        }, null, 8, ["value"]),
                        _createVNode(_component_Button, {
                          icon: "pi pi-upload",
                          rounded: "",
                          "aria-label": "Filter",
                          title: "Subir QR a la Aplicacion",
                          onClick: _cache[7] || (_cache[7] = $event => (_ctx.uploadCanvaToStorage()))
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Actualizar Información",
            severity: "success",
            loading: _ctx.loader,
            icon: "pi pi-save",
            title: "Guardar Datos"
          }, null, 8, ["loading"])
        ])
      ])
    ], 32)
  ], 64))
}